import scrollToElement from "@ecom/ui/utils/scrollToElement"

export default function scrollToPersonalForm() {
  const form = document.getElementById("personal-form")

  if (form) {
    scrollToElement(form)
  }
}
